import GalaxyButton, { type ButtonProps } from "@galaxy-io/dls/buttons/Button";

// DLS 2 preserves native form submission and forwards overlay trigger props/ref.
export const Button = GalaxyButton;
export type { ButtonProps };
